import { useState } from 'react'
import GroupRow from '../GroupRow'
import {
	EuiProgress,
	EuiPanel,
} from '@equipmentshare/ds2'

import { TABLE_HEIGHT } from 'views/helpers/utils'
import { Group } from '../../index'

export type GroupsListProps = {
	groups: Group[],
	isLoading: boolean,
	onEditGroup: ( group: Group ) => () => void,
}

export default function GroupsList( { groups, isLoading, onEditGroup }: GroupsListProps ) {
	const [ expandedIds, setExpandedIds ] = useState<number[]>( [] )

	const toggleIsExpanded = ( id: number ) => () => {
		if ( expandedIds.includes( id ) ) {
			setExpandedIds( expandedIds.filter( ( expId ) => expId !== id ) )
		} else {
			setExpandedIds( [ ...expandedIds, id ] )
		}
	}

	return (
		<EuiPanel paddingSize="none" className="eui-yScroll" hasShadow={false} style={{ height: TABLE_HEIGHT }}>
			{ isLoading && <EuiProgress size="xs" /> }
			{ groups.map( ( group ) => (
				<GroupRow
					key={group.id}
					group={group}
					isOpen={expandedIds.includes( group.id )}
					onToggle={toggleIsExpanded( group.id )}
					onEditClick={onEditGroup( group )}
				/>
			) ) }
		</EuiPanel>
	)
}
